export default __webpack_public_path__ + "static/chair_overview_green-13bd00bb709ce6bd3c374e663112dfc4.jpeg";